import styled from 'styled-components';

interface Props {
  selected: boolean
}

export const Container = styled.div<Props>`
  background-color: ${props => props.theme.colors.background};
  width: 10rem;
  height: 6rem;
  border-radius: 10px;

  border: 1px solid;
  border-color: ${props => props.selected ? props.theme.colors.primary : props.theme.colors.border_grey};

  -webkit-box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

`;

export const Image = styled.img`
  width: 2rem;
  padding-block: 10px;
`;

export const Title = styled.span<Props>`
  font-size: 18px;
  color: ${props => props.selected ? props.theme.colors.primary : props.theme.colors.text};
  font-weight: 700;
`; 
